import type { ListSocialPagesResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function listSocialPages(): Promise<ListSocialPagesResponse> {
  return apiClient.url("/social-publishing/pages").get().json();
}

export function useSocialPages(): UseQueryResult<
  ListSocialPagesResponse,
  Error
> {
  return useQuery({
    queryFn: listSocialPages,
    queryKey: socialPublishingKeys.pages(),
  });
}
